export default class CaptchaProvider {
    constructor(element, verifyCallback, config = {}) {
        if (new.target === CaptchaProvider) {
            throw new Error("CaptchaProvider is an abstract class and cannot be instantiated directly");
        }
        
        this.element = element;
        this.verifyCallback = verifyCallback;
        this.config = config;
        this.isValidated = false;
        this.token = null;
        this.widgetId = null;
    }

    async initialize(slug, chToken) {
        throw new Error("initialize() must be implemented by subclass");
    }

    async render() {
        throw new Error("render() must be implemented by subclass");
    }

    async reset() {
        throw new Error("reset() must be implemented by subclass");
    }

    async verify(response) {
        this.isValidated = true;
        this.token = response;
        
        if (this.verifyCallback) {
            await this.verifyCallback(response);
        }
    }

    getToken() {
        return this.token;
    }

    isValid() {
        return this.isValidated;
    }

    destroy() {
        this.isValidated = false;
        this.token = null;
        this.widgetId = null;
    }
}